export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 mb-4">
              <span className="text-xs text-accent-400 whitespace-nowrap">关于平台</span>
            </div>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-50 mb-6">关于69视频</h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-300 leading-relaxed">
              <p>
                69视频是一个专注于影视资源聚合的免费在线观看平台。我们汇聚了西瓜视频免费、91在线视频等主流渠道的优质内容，致力于为广大影视爱好者提供一站式的观影服务。
              </p>
              <p>
                平台覆盖电影大全、电视剧全集、综艺节目、动漫番剧、纪录片以及短剧等多种内容类型，支持高清画质流畅播放。无论您想追最新热播剧，还是回味经典老片，69视频都能满足您的需求。
              </p>
              <p>
                我们始终坚持免费、开放的原则，无需注册登录即可直接观看，每日更新最新内容，让每一位用户都能享受便捷、高效的在线观影体验。
              </p>
            </div>
          </div>
          <div className="flex-shrink-0 w-full max-w-[400px] lg:max-w-[440px]">
            <div className="rounded-2xl overflow-hidden aspect-[4/3] bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cozy%20home%20theater%20setup%20with%20large%20screen%20displaying%20abstract%20colorful%20cinematic%20visuals%2C%20comfortable%20sofa%2C%20dim%20ambient%20lighting%20with%20warm%20golden%20glow%2C%20streaming%20entertainment%20atmosphere%2C%20modern%20living%20room%20aesthetic%2C%20soft%20shadows%20and%20rich%20contrast&width=880&height=660&seq=about-platform-02&orientation=landscape"
                alt="69视频平台介绍"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}